import { Injectable } from '@angular/core';

import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

import { LocalidadIDE } from './entity-localidades-ide.model';
import { removerTildes } from '../../../shared/util/util';

@Injectable({
  providedIn: 'root'
})
export class LocalidadesIDEService {
  url: string;

  constructor(private http: HttpClient) {}

  getLocalidadesIDE(departamento: string): Observable<LocalidadIDE[]> {
    let d = removerTildes(departamento);
    return this.http.get<LocalidadIDE[]>(
      `${this.url}/v0/geocode/localidades?alias=false&departamento=${d}`
    );
  }
}
